import Config from "@/common/config";
import { baseAxiosInstance } from "@/api/base";
import type { AxiosResponse } from "axios";
import type { QuotationData, Transport } from "@/common/types/chargeWeight";
import { toRelative } from "@/common/helpers";
import { useChargeweightPersistedStore } from "@/stores/chargeweightPersisted";

const baseQuotationEndpoint = Config.apiEndpoints.quotation;
const sendMailsEndpoint = toRelative(baseQuotationEndpoint + "/send-mails");

/**
 * @summary Sends data retrieved from RPG and quotation form to EtcBackend to trigger sending of mails
 * @success If false, no fitting transports were found, so we need to send a different mail with less information
 */
async function sendMails(
  data: QuotationData,
  success: boolean,
  id: string | undefined,
  transport?: Transport,
): Promise<AxiosResponse> {
  const chargeWeightStore = useChargeweightPersistedStore();
  const payload = {
    ...data,
    // Add specific measurement metrics only needed for the mail process
    chargeWeight: {
      ...data.chargeWeight,
      metricMeasurement: chargeWeightStore.metricMeasurement,
      metricVolumeMeasurement: chargeWeightStore.metricVolumeMeasurement,
    },
    // Conditionally include selected transport details if provided
    ...(transport ? { transport: transport } : {}),
  };

  const url = `${sendMailsEndpoint}?success=${success}&id=${id}`;
  return baseAxiosInstance.post(url, payload);
}
export const quotationAPI = {
  sendMails,
};
